module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-sample-04.ea8cb6b9.jpg";